module.exports = __webpack_public_path__ + "static/img/r_2_inactive.f06db18.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/renew_mobile/r_2_inactive.png
// module id = SzLe
// module chunks = 0